const Title = ({ children }) => <b>{children} Data Item Barang</b>

export default Title